<template>
  <div class="card d-flex flex-column">
    <div class="my-image">
      <a :href="url('/4-engeneering/' + item.name)">
        <img :src="url(item.img)" />
      </a>
    </div>
    <div class="my-text">
      <div class="row">
        <div class="col-md-12 description">
          <h2 class="my-caps mb-3">{{ item.name }}</h2>
          <p>
            {{ item.description }}
          </p>
        </div>
      </div>
    </div>
    <div class="scopri">
      <a v-if="item.name !== 'Work benches'"
          :href="url('/4-engeneering/' + item.name)"
          class="d-flex align-items-center">
        <span>{{trans.get('public.explore')}}</span>
        <img
            class="pointer"
            :src="url('/media/icons/svg/arrow-right_white.svg')"
            alt=""
        />
      </a>
      <a v-if="item.name === 'Work benches'"
          :href="url('/4-engeneering/Banchi')"
          class="d-flex align-items-center"
      >
      <span>{{trans.get('public.explore')}}</span>
        <img
            class="pointer"
            :src="url('/media/icons/svg/arrow-right_white.svg')"
            alt=""
        />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "eng-card",
  props: ["item"],
  data() {
    return {};
  },
  mounted() {
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.card {
  width: 100%;
  .my-image {
    width: 100%;
    align-self: center;
  }
  .my-text {
    min-height: 200px;
    padding: 20px 20px ;
    @media (max-width: 576px) {
      min-height: 150px;
    }
  }
  img {
    width: 100%;
    max-width: unset;
  }
  background-color: #2f2f34 !important;

  .scopri {
    color: #fff;
    // padding: 20px;
    // margin-left: auto;
    margin-bottom: 50px;
    margin-right: 50px;
    margin-left: auto;
    @media (max-width: 576px) {
      right: 25px;
    }

    a {
      justify-content: center;
    }

    span {
      transition: all 0.5s linear;
    }

    img {
      margin-left: 7px;
      transition: all 0.5s linear;
      width: 40px;

    }

    &:hover {
      img, span {
        margin-left: 20px;
      }
    }

    a:hover {
      color: unset;
    }
  }
}

.row {
  color: #fff;

  h3 {
    color: #fff;
  }
}
.my-caps{
  font-size: 1.5em;
}
@media (min-width: 1921px){
  .card {
    //img {
    //  min-height: 720px ;
    //}
  }
  h2 {
    font-size: 1.5em;
  }
}
</style>
